import React, { useEffect, useRef, useState } from 'react';
import axios from '../axiosAlertConfig';
import incidentAlertLogo from './INCIDENTALERTLIGHTTRANS.png';

const pageStyle = {
  minHeight: '100vh',
  backgroundColor: '#fde8e8',
  backgroundImage: `linear-gradient(rgba(253, 232, 232, 0.84), rgba(253, 232, 232, 0.84)), url(${incidentAlertLogo})`,
  backgroundRepeat: 'no-repeat, no-repeat',
  backgroundPosition: 'center center, center center',
  backgroundSize: 'cover, clamp(340px, 62vw, 760px) auto',
  padding: '1px 16px',
};

export default function MfaLinkComplete() {
  const startedRef = useRef(false);
  const [status, setStatus] = useState('approving');
  const [message, setMessage] = useState('Approving secure sign-in…');

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const fragment = String(window.location.hash || '').replace(/^#/, '');
    const params = new URLSearchParams(fragment);
    const challengeID = String(params.get('challengeID') || '').trim();
    const code = String(params.get('code') || '').trim();
    const token = String(params.get('token') || '').trim();

    // Remove the MFA values from the address bar before making the request.
    window.history.replaceState(
      null,
      document.title,
      `${window.location.pathname}${window.location.search}`
    );

    if (!challengeID || !code || !token) {
      setStatus('error');
      setMessage('This MFA link is invalid or incomplete.');
      return;
    }

    (async () => {
      try {
        const { data } = await axios.post(
          '/LoginNew/complete-one-tap-mfa',
          { challengeID, code, token, clientApp: 'IncidentAlert' },
          { withCredentials: true }
        );

        if (
          !data?.success ||
          data?.approved !== true ||
          data?.clientApp !== 'IncidentAlert'
        ) {
          throw new Error(data?.message || 'Unable to approve MFA.');
        }

        setStatus('approved');
        setMessage(
          data.message ||
            'MFA approved. Return to the browser where you started signing in.'
        );
      } catch (err) {
        console.error('[one-tap MFA IncidentAlert] approval failed:', err);
        setStatus('error');
        setMessage(
          err.response?.data?.message ||
            err.message ||
            'Unable to approve MFA. Return to the original browser and request another link.'
        );
      }
    })();
  }, []);

  return (
    <div style={pageStyle}>
      <div
        style={{
          maxWidth: 440,
          margin: '100px auto',
          padding: 24,
          textAlign: 'center',
          background: 'rgba(255,255,255,0.88)',
          borderRadius: 8,
        }}
      >
        <h2>Incident Alert</h2>

        {status === 'approving' && <p role="status">{message}</p>}

        {status === 'approved' && (
          <div role="status">
            <h3>Sign-in approved</h3>
            <p>{message}</p>
            <p>
              The original browser will finish signing in automatically. Do not
              sign in again on this page. You may close it.
            </p>
          </div>
        )}

        {status === 'error' && (
          <div role="alert">
            <p style={{ color: '#8b0000' }}>{message}</p>
            <p>
              Return to the browser where you started signing in and use the
              backup code or request another link.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
